import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { Action } from "redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import * as actions from "./actions"

import Dialog from "./components/Dialog"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (element: HTMLElement | undefined | null, props: OldUIProps) => void
    showDialogue: () => Action
}

interface OldUIProps {
    cancelIcon: string
    cancelText: string
    confirmAction: () => void
    confirmIcon: string
    confirmText: string
    title: string
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (
        element: HTMLElement | undefined | null,
        props: OldUIProps,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        const {
            cancelIcon,
            cancelText,
            confirmAction,
            confirmIcon,
            confirmText,
            title,
        } = props
        store.dispatch(
            actions.initialize(
                cancelIcon,
                cancelText,
                confirmIcon,
                confirmText,
                title,
            ),
        )

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <Dialog confirmAction={confirmAction} />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    const showDialogue = (): Action =>
        store.dispatch(actions.updateVisibility(true))

    return {
        start,
        showDialogue,
    }
}

export default init
